import { render, staticRenderFns } from "./SampleApplication.vue?vue&type=template&id=0a08dcfc&scoped=true&"
import script from "./SampleApplication.vue?vue&type=script&lang=js&"
export * from "./SampleApplication.vue?vue&type=script&lang=js&"
import style0 from "./SampleApplication.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SampleApplication.vue?vue&type=style&index=1&id=0a08dcfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a08dcfc",
  null
  
)

export default component.exports